export default function CompileSourceInterface(options: any): {
    watch: (callback: any) => void;
};
